import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { VerificationService, SuccessResponse, StudentPersonalInfoViewModel } from '@sheerid/jslib';

interface StepSuccessProps {
    verificationService: VerificationService;
}

const StepSuccessComponent = ({ verificationService }: StepSuccessProps) => {

    const urlParams = new URLSearchParams(window.location.search);
    const programCodeQS = urlParams.get('programCode') || '';

    const personalInfo = verificationService.previousViewModel as StudentPersonalInfoViewModel;
    const verificationId = (verificationService.verificationResponse as SuccessResponse).verificationId || '';
    const programCode = (personalInfo && personalInfo.metadata && personalInfo.metadata.programCode ? personalInfo.metadata.programCode : programCodeQS);

    return (
        <div id="sid-step-success" className="sid-l-container">
            <div className="sid-header sid-l-horz-center sid-l-space-top-md">
                <div className="sid-header__title sid-l-horz-center sid-l-space-top-md">
                    <FormattedHTMLMessage id="step.success.title" defaultMessage="Success! You've been verified." />
                </div>
                <div className="sid-header__subtitle sid-l-horz-center sid-l-two-thirds-width">
                    <FormattedHTMLMessage id="step.success.subtitle" defaultMessage={
                        `Here is your personal coupon code.
                        It is unique to you and can only be used once.`
                    } />
                </div>
            </div>

            <div className="sid-submit sid-l-space-top-md">
                <a href={`https://care.siriusxm.com/sirpromoplanselection_view.action?verificationId=${verificationId}&programCode=${programCode}`} target="_parent" className="sid-btn sid-btn--dark">
                    <FormattedHTMLMessage id="step.success.redirectButtonText" defaultMessage="Use code now" />
                </a>
            </div>


            <div className="sid-footer sid-l-horz-center sid-l-space-top-lg sid-h-small-text">
                <FormattedHTMLMessage id="step.success.verificationOnly"
                    defaultMessage={`
                        SheerID handles verification only.
                        Now that you've been approved, please direct all questions about the
                        promotion terms and/or code use to {companyName} customer service.
                    `}
                    values={{
                        companyName: "SiriusXM",
                    }}
                />
            </div>
        </div>
    );
};

export { StepSuccessComponent };
